import React from 'react'
import { useRecoilValue } from 'recoil'
import {
  ProgressBar,
  TooltipLabel,
  Panel,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Flex,
  FlexItem,
  Title,
  TITLE_VARIANT_L
} from 'mailup-web-components'
import { useIntl } from 'react-intl'

import styled from '@emotion/styled'

import {
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'

import { progressState } from 'Pages/EmailSendingWizard/recoil/state/queue'

const StyledProgressNote = styled(Text)`
  width: 90%;
  text-align: center;
`

const StyledTooltipLabel = styled(TooltipLabel)`
  margin-top: -20px;
  align-self: flex-end;
  margin-bottom: 8px;
`

const BoxProgress = () => {
  const intl = useIntl()
  const { queueStatus, variant, queuedPercentage, toBeQueued } = useRecoilValue(
    progressState
  )

  const percentage = queuedPercentage + ' %'

  return (
    <>
      <Panel>
        <Flex
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          width='90%'
          margin='auto'
        >
          <FlexItem margin='24px 0 0 0'>
            <Title variant={TITLE_VARIANT_L}>
              {queueStatus === BEQUEUE_CONFIG_STATE_RUNNING && (
                <>
                  {toBeQueued}{' '}
                  {intl.formatMessage({
                    id: 'Load.QueueStatus.RecipientsNew'
                  })}
                </>
              )}
              {queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED && (
                <>
                  {toBeQueued}{' '}
                  {intl.formatMessage({
                    id: 'Load.QueueStatus.RecipientsDone'
                  })}
                </>
              )}
              {queueStatus === BEQUEUE_CONFIG_STATE_FAILED && (
                <>
                  {'-- '}
                  {intl.formatMessage({
                    id: 'Load.QueueStatus.RecipientsNew'
                  })}
                </>
              )}
            </Title>
          </FlexItem>
          <StyledTooltipLabel variant={variant}>
            {queueStatus === BEQUEUE_CONFIG_STATE_FAILED && (
              <Text variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.AsyncDetail.Error' })}
              </Text>
            )}
            {queueStatus === BEQUEUE_CONFIG_STATE_RUNNING && (
              <Text variant={TEXT_VARIANT_BOLD}>
                {percentage}
                {intl.formatMessage({
                  id: 'Load.EmailSendingWizard.QueueProgress'
                })}
              </Text>
            )}
            {queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED && (
              <Text variant={TEXT_VARIANT_BOLD}>
                {percentage}
                {intl.formatMessage({
                  id: 'Load.EmailSendingWizard.QueueProgress'
                })}
              </Text>
            )}
          </StyledTooltipLabel>
          <FlexItem width='100%'>
            <ProgressBar width={queuedPercentage} variant={variant} />
          </FlexItem>
          <FlexItem margin='8px 0 0 0'>
            <StyledProgressNote variant={TEXT_VARIANT_LIGHT} htmlElement='p'>
              {intl.formatMessage(
                { id: 'Load.QueueStatus.RecipientsProgress' },
                { strong: chunks => <strong>{chunks}</strong> }
              )}
            </StyledProgressNote>
          </FlexItem>
        </Flex>
      </Panel>
    </>
  )
}

export default BoxProgress
